var _circle, _ellipse, _ellipse2, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyKnowPartially(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000144309192109457339450000012241874579966267559_",
    cx: 512,
    cy: 512,
    r: 452.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5779,
    style: {
      stopColor: "#FDCD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    style: {
      stopColor: "#FBC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9338,
    style: {
      stopColor: "#F7BA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#F5B200"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_00000144309192109457339450000012241874579966267559_)",
    cx: 512,
    cy: 512,
    r: 452.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -33.5462 532.8658)",
    cx: 352.7,
    cy: 289.7,
    rx: 90.1,
    ry: 58.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137749e-02 7.137749e-02 0.9974 -22.0393 51.1918)",
    cx: 705.3,
    cy: 334,
    rx: 58.8,
    ry: 90.1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 28.2902,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M275.9,659.3c142.2,80.7,349.3,39.5,430.3-105.1"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000001643497226005570980000011043642123644364465_",
    cx: 512,
    cy: 512,
    r: 506.6378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5779,
    style: {
      stopColor: "#FDCD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    style: {
      stopColor: "#FBC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9338,
    style: {
      stopColor: "#F7BA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#F5B200"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "url(#SVGID_00000001643497226005570980000011043642123644364465_)",
    strokeWidth: 13.8,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512,
    r: 499.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyKnowPartially);
export default __webpack_public_path__ + "static/media/smiley-know-partially.1b284ffc9147675262011b10ab47957a.svg";
export { ForwardRef as ReactComponent };